import React, {useState, useEffect} from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
// componentes
import ZonaCargando from "../zonaCargando";
import SidebarCamarografo from "../../partials/sidebarCamarografo";

function HomeCamarografo(){
    const navigate = useNavigate();
    const routeParams = useParams();

    const [usuario, setUsuario]               = useState(null);
    const [cargando, setCargando]             = useState(false);
    const [infoUsuarioLocal, setInfoLocal]    = useState({}); // Variables localstorage
    const [partidosGrabar, setPartidosGrabar] = useState([]);
    const [torneos, setTorneos]               = useState([]);
    let {username} = routeParams; // capturamos 
    




    useEffect(() => {
    (async () => {
      try {
        setCargando(true);

        const verifToken = axios.get("/verificar-token", { withCredentials: true });
        const pPartidos  = axios.post("/obtener-partidos-grabar-home");

        const [ resVerif, resPartidos ] = await Promise.all([verifToken, pPartidos ]);
        if(!resVerif.data.usuario){ return navigate("/alerta", {state: {titulo:"No estás autenticado", mensaje:"No estás autenticado, por favor inicia sesión.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        if(resVerif.data.usuario.tipo === "Administrador" || resVerif.data.usuario.tipo === "Cliente" ){ cerrarSesion(); return navigate("/alerta", {state: {titulo:"No eres Camarógrafo", mensaje:"No eres camarógrafo.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        setUsuario(resVerif.data.usuario);
        // partidos
        setPartidosGrabar(resPartidos.data.partidosSinEditar); 
        setTorneos(resPartidos.data.torneos);
      } 
      catch (err) { console.error("Error en una de las solicitudes:", err); } 
      finally { setCargando(false);}
    })();
    }, []);



    async function cerrarSesion(event) {
        localStorage.clear(); // Limpiamos el almacenamiento local.
        const resCerrar = await axios.post("/logout");
    }

    
    
    
    
    const[input, setInput] = useState ({
        busqueda: "",
        idBusqueda: "",
        torneoSeleccionado: "",
        partidoSeleccionado: "",
    });

    function handleChange(event){
        const {name, value} = event.target;
        // Permite letras, números y espacios
        const filteredValue = value.replace(/[^A-Za-z0-9\s]/g, '');
        setInput(prevInput => { return { ...prevInput, [name]: filteredValue } });
    }

    async function buscarPartido(event){
        event.preventDefault();

        if(input.busqueda===""){ alert("debes seleccionar un filtro de búsqueda. Intenta de nuevo."); }        
        else if(input.busqueda==="id" && input.idBusqueda===""){ window.location.reload(); alert("Debes añadir un id del partido. Intenta de nuevo.");}
        else if(input.busqueda==="partidoBusqueda" && input.partidoSeleccionado===""){ window.location.reload(); alert("Debes seleccionar un partido de la lista. Intenta de nuevo.");}
        else if(input.busqueda==="torneoBusqueda" && input.torneoSeleccionado===""){ window.location.reload(); alert("Debes seleccionar un torneo de la lista. Intenta de nuevo.");}
        else{

            await axios.post("/buscar-desde-camarografo", {
                params: { tipoBusqueda: input.busqueda, idPartidoBusqueda: input.idBusqueda, torneoBusqueda: input.torneoSeleccionado, partidoBusqueda: input.partidoSeleccionado }
            })
            .then(async function(response){
                if(response.data.status===400){  window.location.reload(); alert(response.data.mensaje);}
                // Opción 1 - para ver partidos
                else if(response.data.status===200 && response.data.opcion===1){
                    let url = "/camarografo/ver-partido-encontrado/" + username;
                    return navigate(url, {state: {partido: response.data.partido} } );
                }
            });
        }
    }

   


    return(
    <div>
    {cargando ? <ZonaCargando /> : 
    !usuario ? null : 
    <div className='contenedorPaginasUsuario'>
        <div className='contenedorSidebarYcontenido d-flex flex-row '>

            {/* BARRA LATERAL */}
            <SidebarCamarografo />


            {/* Columna 2 */}
            <div className="flex-grow-1 container-fluid">
                
                {/* Contenedor título  */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 text-light">Home</h1>

                    <div className="d-flex align-items-center">
                        <h4 className="textoHomeUsuario mx-2 text-light">Hola {username}</h4>
                    </div>
                </div>

                {/* Contenedor formulario */}
                <div className="p-5 mb-4 contenedorOscuro rounded-3">                   
                    <div className="container">
                        <h2 style={{textAlign: "center"}} >Buscar partidos</h2>
                        <p  style={{textAlign: "center"}}>Ingresa los datos para buscar un partido.</p>

                        {/* FORMULARIO ////////////////////////////////////////////*/}
                        <form className="mt-5">
                            {/* Busqueda */}
                            <div className="form-floating mb-3">
                            <select onChange={handleChange} value={input.busqueda} name="busqueda" className="form-select" id="floatingCategoria">
                                <option value="">Buscar por</option>
                                <option value="id">id: Escribe el id del partido</option>
                                {/* <option value="partidoBusqueda">Partido: selecciona el partido</option> */}
                                {/* <option value="torneoBusqueda">Torneo: selecciona el torneo</option> */}
                            </select>
                            <label htmlFor="floatingCategoria">Filtro</label>
                            </div>

                            {/* id */}
                            <div className="form-floating mb-3">
                                <input onChange={handleChange} value={input.idBusqueda} name="idBusqueda" type="number" className="form-control" id="floatingInput" placeholder="nombre"   title="Solo puede contener letras y números." />
                                <label htmlFor="floatingInput">id del Partido</label>
                            </div>

                            {/* Torneo */}
                            {/* <div className="form-floating mb-3">
                                <select onChange={handleChange} value={input.torneoSeleccionado} name="torneoSeleccionado" className="form-select" aria-label="Seleccione torneo">
                                    <option value="">Seleccionar torneo</option>
                                    {(torneos) ? torneos.map(torneo => (
                                    <option key={torneo.idTorneo} value={torneo.idTorneo}>{torneo.nombre}</option>
                                    )):null}
                                </select>
                                <label>Torneo</label>
                            </div> */}

                            {/* Partido */}
                            {/* <div className="form-floating mb-3">
                                <select onChange={handleChange} value={input.partidoSeleccionado} name="partidoSeleccionado" className="form-select" aria-label="Seleccione partido">
                                    <option value="">Seleccionar Partido</option>
                                    {(partidosGrabar) ? partidosGrabar.map(partido => (
                                    <option key={partido._doc.idPartido} value={partido._doc.idPartido}>{partido.nombrePartido}</option>
                                    )):null}
                                </select>
                                <label>Partido</label>
                            </div> */}

                            {/* Botón enviar */}
                            <button onClick={buscarPartido} type="submit" style={{width: "100%"}} className="btn btn-primary">Buscar Partido</button>
                        </form>

                        {/* FORMULARIO ////////////////////////////////////////////*/}
                    </div>
                </div>
        
            </div>
        </div>
    </div>
    }
    </div>
    )
}

export default HomeCamarografo;